import registrationSchema from "./list/registration"

const schemas = {
    registration: registrationSchema
}



export default schemas